import { validate } from 'uuid';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useIdentity } from '@zenbusiness/application-commons-identity';
import { useError } from '@zenbusiness/application-commons-logging';

export const MODAL_QUERY = gql`
  query ModalQuery($identity: CustomerIdentity!, $constraintOverrides: [ConstraintOverride]) {
    modal(identity: $identity, constraintOverrides: $constraintOverrides) {
      instanceUuid
      uuid
      inAppKey
      topic
      subtitle
      title
      ctaUrl
      ctaType
      ctaLabel
      image
      caption
      readinessStatus
    }
  }
`;

export function useModal() {
  const { businessEntityUuid } = useBusinessEntity();
  const { accountUuid, userUuid } = useIdentity();

  const {
    data, loading, errors
  } = useQuery(MODAL_QUERY, {
    noThrow: true,
    skip: !businessEntityUuid || !accountUuid || !userUuid || !validate(businessEntityUuid),
    useCache: false,
    variables: {
      identity: {
        businessEntityUuid,
        accountUuid,
        userUuid,
        inAppTypes: ['modal']
      }
    }
  });

  useError(errors);

  return {
    data: data?.modal || [],
    error: errors?.[0],
    loading
  };
}
